import { areYouSureModalStore } from './areYouSureModalStore';

export const waitForAnswer = ({ content, options }) => {
  return areYouSureModalStore.open({ content, options });
};
